export const STATUS_CATEGORY = {
  [1]: "Informational",
  [2]: "Success",
  [3]: "Redirection",
  [4]: "Client Error",
  [5]: "Server Error",
};
